import React from 'react'
import gif from '../images/stoop.gif'

export default function Loading () {
    return (
        <div style={{display:"flex", height:"100vh", flex:1, justifyContent:"center", alignItems:"center"}}>
            <img alt="stoop" src={gif} style={{borderRadius:50}} />
        </div>
    )
}